import { render, staticRenderFns } from "./TaylorMade.vue?vue&type=template&id=b7ce1e46&scoped=true&"
import script from "./TaylorMade.vue?vue&type=script&lang=js&"
export * from "./TaylorMade.vue?vue&type=script&lang=js&"
import style0 from "./TaylorMade.vue?vue&type=style&index=0&id=b7ce1e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ce1e46",
  null
  
)

export default component.exports